module.exports = __webpack_public_path__ + "static/media/spin-wheel-button-center.b7744dc2.png";